// src/modules/app-views/serviceOrders/pages/Document/actions/menuButton.js

import { MoreOutlined } from '@ant-design/icons';
import {
  dropdownArchive,
  dropdownDivider,
  dropdownDuplicate,
  dropdownNew,
  dropdownRemove,
  dropdownRemovePermanently,
  dropdownRestore,
} from 'layouts/Pages/PageHeader/dropdownMenus';

const serviceOrdersDocumentMenuButton = () => {
  return {
    action: 'dropdownMenu',
    icon: <MoreOutlined />,
    tooltip: 'more_options',

    dropdownItems: [
      dropdownNew,
      dropdownDuplicate,
      dropdownDivider,
      dropdownArchive,
      dropdownRemove,
      dropdownRestore,
      dropdownRemovePermanently,
    ],
  };
};

export default serviceOrdersDocumentMenuButton;
